if (!customElements.get('yc-package-gift')) {
  customElements.define('yc-package-gift', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      const toggle = this.querySelector('[data-yc-package-gift-toggle]');
      const fields = this.querySelector('[data-yc-package-gift-fields]');
      if (!toggle || !fields) return;
      this.dataset.initialized = 'true';
      const inputs = fields.querySelectorAll('[data-yc-package-gift-input]');
      const sender = this.querySelector('[data-yc-package-gift-sender]');
      const update = () => {
        const enabled = toggle.checked;
        fields.hidden = !enabled;
        toggle.setAttribute('aria-expanded', String(enabled));
        inputs.forEach(input => { input.disabled = !enabled; });
        if (sender) sender.required = enabled;
      };
      toggle.addEventListener('change', update);
      this.closest('form')?.addEventListener('reset', () => setTimeout(update, 0));
      update();
    }
  });
}
